import { useRouter } from 'next/router';
import React, { FunctionComponent, useContext } from 'react';
import { Box } from '@wix/design-system';
import { isCI } from '@wix/wix-run-mode';
import { LanguageSupportedNotification } from './LanguageSupportedNotification';
import { StatusPageNotification } from './StatusPageNotification';
import { PageType } from '../../types';
import { Context } from '../../context';
import { WixStudioNotification } from './WixStudioNotification';
import { useExperiments } from '@wix/fe-essentials-standalone';
import { EXPERIMENTS, LOCALES } from '../../constants';
import css from './index.module.scss';

type NotificationBarProps = {
  pageType: PageType;
};

export const NotificationBar: FunctionComponent<NotificationBarProps> = ({
  pageType,
}) => {
  const { locale } = useRouter();
  const { isWixStudioUser } = useContext(Context);
  const { experiments } = useExperiments({ readOnly: true });

  const isWixStudioLaunchEnabled = experiments.enabled(
    EXPERIMENTS.SPECS.WIX_STUDIO_LAUNCH
  );

  if (isCI()) {
    return null;
  }

  return (
    <Box className={css.notificationBar} direction="vertical">
      {pageType === PageType.Homepage &&
      locale === LOCALES.EN &&
      isWixStudioUser &&
      isWixStudioLaunchEnabled ? (
        <WixStudioNotification />
      ) : (
        pageType !== PageType.RoadMap && (
          <LanguageSupportedNotification pageType={pageType} />
        )
      )}
      <StatusPageNotification pageType={pageType} />
    </Box>
  );
};
